import { EnumOption } from "./enum-option"

export const OriginalNoticeReceiver = {
    Company: 1,    
    GIP: 2,     
}

export const OriginalNoticeReceiverList: EnumOption[] = [
    { value: OriginalNoticeReceiver.Company, label: 'Company' },    
    { value: OriginalNoticeReceiver.GIP, label: 'GIP' }
]
